import { BaseJob } from "src/app/types/job.type";
import { Job } from ".";
import { BuildServices, GroupActionSortByType } from "./generic-route-event.model";

export class Dropoff extends Job {

  public type = 'dropoff';
  public GroupActionSortByType = GroupActionSortByType.Dropoff;

  constructor(value: BaseJob, services: BuildServices) {
    super(value, services);
    const time = this.scheduledStart ? this.scheduledStart.toFormat('HH:mm') : '00:00';
    this.headerInfo.type = 'LABEL.dropOff';
    this.phoneNumber = value.dropoffPhone || value.phone || '';
  }
}
